import { Chip, CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { Add, InfoOutlined } from "@material-ui/icons";
import { useAuth } from "@airborne/react-admin";
import React, { useEffect, useState } from "react";
import {
  Button,
  Create,
  NumberInput,
  SelectInput,
  TextInput,
  Toolbar,
  maxValue,
  minValue,
  required,
  useNotify,
} from "react-admin";
import { Form } from "react-final-form";
import { useHistory } from "react-router-dom";
import { ExperienceNoteType } from "../../../../../src/Enums/ExperienceNoteType";
import { PbhRequestFileType } from "../../../../../src/Enums/PbhRequestFileType";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import { SectionTitle } from "../../../../Components/SectionTitle";
import { Separator } from "../../../../Components/Separator";
import { HourMinuteInput } from "../../../../Components/HourMinuteInput";
import { GetPbhCarrierType } from "../../../../Enums/PbhCarrierType";
import { GetPbhRemoveReasonSubType, UnscheduledRemoveReasonSubType } from "../../../../Enums/RemoveReasonSubType";
import { GetPbhRemoveReasonType, PbhRemoveReasonType } from "../../../../Enums/PbhRemoveReasonType";
import { UnserviceableStatu } from "../../../../Enums/UnserviceableStatus";
import { useAppDataProvider } from "../../../../dataprovider";
import { PbhRequestUnserviceablePostModel } from "../../Models/PbhRequestUnserviceableModel";
import ExperienceSoftWarningDialog from "../ExperiencePopup";
import { PbhRequestStatus } from "../../../../Enums/PbhRequestStatus";
import { OwnerType, OwnerTypeDesc } from "../../../../Enums/OwnerTypes";
import { ServiceableStatu } from "../../../../../src/Enums/ServiceableStatus";
import PbhServiceableRequiredDialog from "../../../../../src/Components/PbhServiceableRequiredPopup/PbhServiceableRequiredPopup";
import WarningDialog from "../../../../../src/Components/WarningDialog/WarningDialog";
import { RemoveDateFromAcNonRequiredStatus } from "./Constant/Constant";

const useStyles = makeStyles({
  toolbar: {
    display: "flex",
    justifyContent: "end",
    backgroundColor: "white",
  },
  defaultToolbar: {
    display: "flex",
    justifyContent: "end",
  },
});

const UnserviceableCreate = props => {
  const { user } = useAuth();
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [isFlyDubai, setIsFlyDubai] = useState<boolean>(false);
  const [showServiceableRequiredDialog, setShowServiceableRequiredDialog] = useState(false);
  const [showServiceableOfferedWarningDialog, setShowServiceableOfferedWarningDialog] = useState(false);
  const classes = useStyles();
  const requestId = props?.requestId;
  const requestDetail = props?.requestDetail;
  const requestServiceable = props?.requestDetail?.pbhRequestServiceable;

  useEffect(() => {
    var flyDubai = OwnerTypeDesc.find(x => x.Value == OwnerType.AARFLYDB)?.Description;
    setIsFlyDubai(user?.ownerCode === flyDubai);
  }, []);
  const CreateUnserviceableButtonClick = async e => {
    // Check if Remove Reason Type is RejectedQuarantinedPart and Serviceable is not accepted/rejected
    if (e.removeReasonType === PbhRemoveReasonType.RejectedQuarantinedPart) {
      const isServiceableAcceptedOrRejected =
        requestServiceable?.status === ServiceableStatu.Accepted ||
        requestServiceable?.status === ServiceableStatu.Rejected;

      if (!isServiceableAcceptedOrRejected) {
        setShowServiceableRequiredDialog(true);
        return;
      }
    }
    if (requestServiceable?.status === ServiceableStatu.Offered) {
      setShowServiceableOfferedWarningDialog(true);
    }
    CreateUnserviceable(e);
  };

  const CreateUnserviceable = async e => {
    let pbhRequestUnserviceableCreateModel: PbhRequestUnserviceablePostModel = new PbhRequestUnserviceablePostModel();
    pbhRequestUnserviceableCreateModel.RequestId = requestId;
    pbhRequestUnserviceableCreateModel.Pn = e.pn;
    pbhRequestUnserviceableCreateModel.Sn = e.sn;
    pbhRequestUnserviceableCreateModel.Awb = e.awb;
    pbhRequestUnserviceableCreateModel.CarrierEnum = e.carrierEnum;
    pbhRequestUnserviceableCreateModel.FlightNo = e.flightNo;
    pbhRequestUnserviceableCreateModel.ForwardDateToCarrier = e.forwardDateToCarrier;
    pbhRequestUnserviceableCreateModel.EstimatedDeliveryDate = e.estimatedDeliveryDate;
    pbhRequestUnserviceableCreateModel.Ac = e.ac;
    pbhRequestUnserviceableCreateModel.Batch = e.batch;
    pbhRequestUnserviceableCreateModel.RemoveReasonType = e.removeReasonType;
    pbhRequestUnserviceableCreateModel.RemoveReasonSubType = e.removeReasonSubType;
    pbhRequestUnserviceableCreateModel.RemoveDateFromAc = e.removeDateFromAc === "" ? null : e.removeDateFromAc;
    pbhRequestUnserviceableCreateModel.Tso = e.tso;
    pbhRequestUnserviceableCreateModel.Cso = e.cso;
    pbhRequestUnserviceableCreateModel.Dso = e.dso;
    pbhRequestUnserviceableCreateModel.Tsr = e.tsr;
    pbhRequestUnserviceableCreateModel.Csr = e.csr;
    pbhRequestUnserviceableCreateModel.Dsr = e.dsr;
    pbhRequestUnserviceableCreateModel.Tsn = e.tsn;
    pbhRequestUnserviceableCreateModel.Csn = e.csn;
    pbhRequestUnserviceableCreateModel.Dsn = e.dsn;
    pbhRequestUnserviceableCreateModel.Tsi = e.tsi;
    pbhRequestUnserviceableCreateModel.Csi = e.csi;
    pbhRequestUnserviceableCreateModel.Dsi = e.dsi;
    pbhRequestUnserviceableCreateModel.Status = UnserviceableStatu.Offered;
    pbhRequestUnserviceableCreateModel.Remark = e.remark;
    pbhRequestUnserviceableCreateModel.RemovalReasonDetail = e.removalReasonDetail;
    pbhRequestUnserviceableCreateModel.AdSbMod = e.adSbMod;
    pbhRequestUnserviceableCreateModel.Dom = e.dom;
    pbhRequestUnserviceableCreateModel.Nla = e.nla;
    pbhRequestUnserviceableCreateModel.Nha = e.nha;
    pbhRequestUnserviceableCreateModel.EngineSerialNumber = e.engineSerialNumber;
    pbhRequestUnserviceableCreateModel.RejectionRemark = e.rejectionRemark;

    PostCreate(pbhRequestUnserviceableCreateModel);
  };

  const PostCreate = async (pbhRequestUnserviceablePostModel: PbhRequestUnserviceablePostModel) => {
    setLoading(true);
    dataProvider
      .postPbhRequestUnserviceable(pbhRequestUnserviceablePostModel)
      .then(result => {
        props?.finalCallBack?.();
        notify(`Record created`, "success", false, true);
        history.push("/pbhrequestorders/" + requestId + "/2");
      })
      .catch(result => notify(`${result}`, "error", false, true))
      .finally(() => setLoading(false));
  };

  const resetValidate = form => e => {
    setTimeout(() => form?.restart?.(form?.getState?.()?.values), 500);
  };

  const removeReasonChangeEvent = form => e => {
    form.change("removeReasonSubType", null);
    if (e.target.value === PbhRemoveReasonType.ServiceableReturn) {
      form.change("tsi", 0);
      form.change("csi", 0);
      form.change("dsi", 0);
      // form.change('removeDateFromAc', moment.utc().local())
    }
  };

  const handleCloseServiceableRequiredDialog = () => {
    setShowServiceableRequiredDialog(false);
  };

  const handleCloseServiceableOfferedWarningDialog = () => {
    setShowServiceableOfferedWarningDialog(false);
  };

  const handleNavigateToServiceable = () => {
    setShowServiceableRequiredDialog(false);
    history.push("/pbhrequestorders/" + requestId + "/1");
  };

  const IsCreated = values => {
    if (props?.requestDetail?.requestStatus === PbhRequestStatus.Cancelled) {
      return false;
    }

    let isUnUsedStatement =
      props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.UnusedStatement
      )?.length === 0
        ? false
        : true;

    if (values.removeReasonType === PbhRemoveReasonType.ServiceableReturn) {
      if (!isUnUsedStatement) {
        return false;
      }
    }

    let isUsTagExist =
      props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
        x =>
          x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable &&
          x.pbhRequestFileTypeEnum === PbhRequestFileType.UsTag
      )?.length === 0
        ? false
        : true;
    //Reliability US TAG file check if FoF
    if (
      values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
    ) {
      if (!isUsTagExist) {
        return false;
      }
      if (values.tsi !== 0 || values.csi !== 0) {
        return false;
      }
    }

    if (
      values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
      values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure
    ) {
      if (!isUsTagExist) {
        return false;
      }
      if (values.tsi === 0 || values.tsi > 30000) {
        return false;
      }
    }

    return true;

    // let isAwbExist =
    //   props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
    //     (x) => x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable && x.pbhRequestFileTypeEnum === PbhRequestFileType.Awb
    //   )?.length === 0
    //     ? false
    //     : true

    // let isShippingInvoiceExist =
    //   props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
    //     (x) => x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable && x.pbhRequestFileTypeEnum === PbhRequestFileType.ShippingInvoice
    //   )?.length === 0
    //     ? false
    //     : true
    // let shippingInvoiceAwb =
    //   props?.requestDetail?.pbhRequestOrderFiles?.filter?.(
    //     (x) => x.pbhRequestFileTypeGroupEnum === PbhRequestFileType.Unserviceable && x.pbhRequestFileTypeEnum === PbhRequestFileType.ShippingInvoiceAwb
    //   )?.length === 0
    //     ? false
    //     : true

    // return (isAwbExist && isShippingInvoiceExist) || shippingInvoiceAwb
  };

  return (
    <>
      <Form
        onSubmit={CreateUnserviceableButtonClick}
        render={({ handleSubmit, form, values }) => {
          return (
            <form>
              <Create {...props}>
                <>
                  <Grid container justifyContent="space-around" spacing={2}>
                    <Grid item xs={12} container justifyContent="space-around">
                      <SectionTitle label="Core Unit Info" />
                    </Grid>
                    <Separator />
                    <Grid item xs={12} container justifyContent="space-around">
                      <Grid item xs={6} container direction="column" alignItems="center">
                        <Grid item xs={10}>
                          <TextInput
                            source="pn"
                            label="PN"
                            fullWidth
                            resettable
                            variant="outlined"
                            validate={required()}
                            defaultValue={requestDetail?.unserviceablePn}
                          />
                          <TextInput
                            source="sn"
                            label="SN"
                            fullWidth
                            variant="outlined"
                            validate={required()}
                            defaultValue={requestDetail?.unserviceableSn}
                          />
                          <TextInput
                            source="ac"
                            label="AC"
                            fullWidth
                            variant="outlined"
                            validate={required()}
                            defaultValue={requestDetail?.aircraft?.acReg}
                          />
                          <NumberInput source="batch" label="Batch" fullWidth variant="outlined" />
                          <CustomDatetime
                            fullWidth
                            source="removeDateFromAc"
                            label="Remove Date from AC"
                            variant="outlined"
                            showTime
                            maxDate={values.forwardDateToCarrier}
                            validate={[
                              ...(!RemoveDateFromAcNonRequiredStatus.includes(values.removeReasonType)
                                ? [required()]
                                : []),
                              maxValue(values.forwardDateToCarrier, "Should be before than Forward Date To Carrier"),
                            ]}
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />

                          <Grid container spacing={1}>
                            <Grid item xs>
                              <HourMinuteInput
                                source="tso"
                                label="TSO (Hour)"
                                hourDigits={7}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="cso" label="CSO (Cycle)" fullWidth variant="outlined" />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="dso" label="DSO (Days)" fullWidth variant="outlined" />
                            </Grid>
                          </Grid>
                          <Grid container spacing={1}>
                            <Grid item xs>
                              <HourMinuteInput
                                source="tsr"
                                label="TSR (Hour)"
                                hourDigits={7}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="csr" label="CSR (Cycle)" fullWidth variant="outlined" />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="dsr" label="DSR (Days)" fullWidth variant="outlined" />
                            </Grid>
                          </Grid>
                          <Grid container spacing={1}>
                            <Grid item xs>
                              <HourMinuteInput
                                source="tsn"
                                label="TSN (Hour)"
                                hourDigits={7}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="csn" label="CSN (Cycle)" fullWidth variant="outlined" />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="dsn" label="DSN (Days)" fullWidth variant="outlined" />
                            </Grid>
                          </Grid>
                          <Grid item container spacing={1}>
                            {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                              values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit &&
                              (values.tsi !== 0 || values.csi !== 0) && (
                                <Chip
                                  key={9999990}
                                  color="primary"
                                  variant="outlined"
                                  label="Removal reason was selected as Unscheduled - Fail On Fit, TSI and CSI hour input must be 0."
                                  icon={<InfoOutlined />}
                                />
                              )}
                          </Grid>
                          <Grid item container spacing={1}>
                            {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                              values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure &&
                              (values.tsi === 0 || values.tsi > 30000) && (
                                <Chip
                                  key={9999980}
                                  color="primary"
                                  variant="outlined"
                                  label="Removal reason was selected as Unscheduled - Premature, TSI hour cannot be 0 and must be less than 500 FH."
                                  icon={<InfoOutlined />}
                                />
                              )}
                          </Grid>
                          <Grid item container spacing={1}>
                            <Grid item xs>
                              <HourMinuteInput
                                source="tsi"
                                label="TSI (Hour)"
                                hourDigits={7}
                                fullWidth
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="csi" label="CSI (Cycle)" fullWidth variant="outlined" />
                            </Grid>
                            <Grid item xs>
                              <NumberInput source="dsi" label="DSI (Days)" fullWidth variant="outlined" />
                            </Grid>
                          </Grid>
                          <TextInput source="dom" label="DOM" fullWidth variant="outlined" />
                          <TextInput source="nha" label="NHA" fullWidth variant="outlined" />
                          {values.removeReasonType === PbhRemoveReasonType.RejectedQuarantinedPart &&
                            !values.isRejectionOrder && (
                              <TextInput
                                source="rejectionRemark"
                                label="Rejection Remark"
                                multiline
                                fullWidth
                                resettable
                                variant="outlined"
                                validate={
                                  values.removeReasonType === PbhRemoveReasonType.RejectedQuarantinedPart
                                    ? required()
                                    : []
                                }
                              />
                            )}
                        </Grid>
                      </Grid>
                      <Grid item xs={6} container direction="column" alignItems="center">
                        <Grid item xs={10}>
                          <TextInput
                            source="awb"
                            label="AWB"
                            fullWidth
                            variant="outlined"
                            validate={isFlyDubai ? [] : required()}
                          />
                          <TextInput source="flightNo" label="Flight No" fullWidth variant="outlined" />
                          <SelectInput
                            source="carrierEnum"
                            label="Carrier Type"
                            choices={GetPbhCarrierType}
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            variant="outlined"
                            validate={isFlyDubai ? [] : required()}
                          />
                          <CustomDatetime
                            fullWidth
                            source="forwardDateToCarrier"
                            label="Forward Date To Carrier"
                            variant="outlined"
                            showTime
                            minDate={values.removeDateFromAc}
                            maxDate={values.estimatedDeliveryDate}
                            validate={[
                              isFlyDubai ? [] : required(),
                              minValue(values.removeDateFromAc, "Should be later than Remove Date from Ac"),
                              maxValue(values.estimatedDeliveryDate, "Should be before Forward Date to Carrier"),
                            ]}
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />
                          <CustomDatetime
                            fullWidth
                            source="estimatedDeliveryDate"
                            label="Estimated Delivery Date"
                            variant="outlined"
                            showTime
                            minDate={values.forwardDateToCarrier}
                            validate={[
                              isFlyDubai ? [] : required(),
                              minValue(values.forwardDateToCarrier, "Should be later than Forward Date to Carrier"),
                            ]}
                            onChange={resetValidate(form)}
                            onBlur={resetValidate(form)}
                          />
                          <SelectInput
                            source="removeReasonType"
                            label="Remove Reason Type"
                            choices={GetPbhRemoveReasonType}
                            optionText="Description"
                            optionValue="Value"
                            fullWidth
                            variant="outlined"
                            onChange={removeReasonChangeEvent(form)}
                            validate={required()}
                          />
                          {GetPbhRemoveReasonSubType(values.removeReasonType) && (
                            <SelectInput
                              source="removeReasonSubType"
                              label="Remove Reason Sub Type"
                              choices={GetPbhRemoveReasonSubType(values.removeReasonType)}
                              optionText="Description"
                              optionValue="Value"
                              fullWidth
                              variant="outlined"
                              validate={required()}
                            />
                          )}

                          {values.removeReasonType === PbhRemoveReasonType.Unscheduled &&
                            (values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit ||
                              values.removeReasonSubType === UnscheduledRemoveReasonSubType.PrematureFailure) && (
                              <Chip
                                key={9999990}
                                color="primary"
                                variant="outlined"
                                label={
                                  values.removeReasonSubType === UnscheduledRemoveReasonSubType.FailOnFit
                                    ? "Please Upload US TAG for Unserviceable Fail On Fit Requests!"
                                    : "Please Upload US TAG for Unserviceable Premature Failure Requests!"
                                }
                                icon={<InfoOutlined />}
                              />
                            )}
                          {values.removeReasonType === PbhRemoveReasonType.ServiceableReturn && (
                            <Chip
                              key={9999990}
                              color="primary"
                              variant="outlined"
                              label={"You must upload Unused Statement file."}
                              icon={<InfoOutlined />}
                            />
                          )}
                          <TextInput
                            source="remark"
                            label="Remarks of Customer"
                            multiline
                            resettable
                            fullWidth
                            rows={4}
                            variant="outlined"
                          />
                          <TextInput
                            source="removalReasonDetail"
                            label="Removal Reason Detail"
                            fullWidth
                            variant="outlined"
                          />
                          <TextInput source="nla" label="NLA" fullWidth variant="outlined" />
                          <TextInput source="adSbMod" label="AD(SB/MOD)" fullWidth variant="outlined" />
                          <TextInput
                            source="engineSerialNumber"
                            label="Engine Serial Number"
                            fullWidth
                            resettable
                            variant="outlined"
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Separator />
                    <Grid item xs={12}>
                      <Toolbar {...props} placeholder="" classes={classes}>
                        {user?.isCustomer && (
                          <Button
                            label={loading ? "Core Unit is creating!" : "Create Core Unit"}
                            disabled={props.isPageDisabled || (loading ? true : !IsCreated(values))}
                            size="medium"
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                          >
                            {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                          </Button>
                        )}
                      </Toolbar>
                    </Grid>
                  </Grid>
                </>
              </Create>
            </form>
          );
        }}
      />
      <ExperienceSoftWarningDialog data={props?.requestDetail?.experience} type={ExperienceNoteType.Unserviceable} />
      <PbhServiceableRequiredDialog
        open={showServiceableRequiredDialog}
        onClose={handleCloseServiceableRequiredDialog}
        onNavigateToServiceable={handleNavigateToServiceable}
      />
      <WarningDialog
        open={showServiceableOfferedWarningDialog}
        onClose={handleCloseServiceableOfferedWarningDialog}
        title="Warning!"
        message="Please Accept or Reject Serviceable component offer on Serviceable tab as soon as possible."
      />
    </>
  );
};

const PbhRequestUnserviceableCreate = props => {
  return (
    <UnserviceableCreate
      resource="/pbhrequestunserviceables"
      basePath=""
      requestId={props.requestId}
      requestDetail={props.requestDetail}
      finalCallBack={e => props.finalCallBack()}
    />
  );
};

export default PbhRequestUnserviceableCreate;
